














































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import { Tree, TreeOptions, getTreeCaption } from '@/core/components/tree';
import { Page } from '@/core/components/controls';
import {
    DxTreeList
} from 'devextreme-vue/tree-list';
import {
    CONTRACTS,
    EventsServiceContract,
    FetchServiceContract,
    Events
} from '@/core/contracts';
import { lookupField, guid } from '@/core/helpers';
import { ResourceTypeTree } from '@/dto';
import { IContext } from '@/api/dto';
import ResourceTypesListTable from './ResourceTypesListTable.vue';
import ResourceTypesListEditingPage from './components/ResourceTypesListEditingPage.vue';
import DevExpress from 'devextreme/bundles/dx.all';
import ResourceTypesDependences from './types';
import ResourceTypesDependencesList from './components/ResourceTypesDependencesList.vue';

@Component({
    components: {
        DxTreeList,
        ResourceTypesListTable,
        TreeOptions,
        ResourceTypesListEditingPage,
        ResourceTypesDependencesList
    }
})
export default class ResourceTypesListPage extends Page {
    public tree: Tree | null = null;
    public treeKey: string = 'resource-types-control';
    public readOnly: boolean = false;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService) private _eventsService?: EventsServiceContract;

    public setTree(tree: Tree): void {
        this.tree = tree;
    }

    public get popup() {
        const name = 'popup';
        const element = this.$refs[name] as unknown;

        return element as ResourceTypesListEditingPage;
    }

    public get popupDependences() {
        const name = 'popupDependencesList';
        return this.$refs[name] as ResourceTypesDependencesList;
    }

    public get currentItem() {
        if (this.treeInstance) {
            return this.treeInstance.currentItem() as ResourceTypeTree;
        }

        return null;
    }

    public showDependences(relations: ResourceTypesDependences) {
        this.popupDependences.show(relations);
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get treeName(): string {
        return getTreeCaption(this.treeKey);
    }

    public get isRowSelected() {
        return this.tree && this.tree!.getSelectedRowKeys().length === 1;
    }

    public addResourceType() {
        this.popup.showPopUp(this.currentItem, true);
    }

    public editResourceType() {
        this.popup.showPopUp(this.currentItem, false);
    }

    private get treeInstance() {
        return this.$refs['tree-component']  as ResourceTypesListTable;
    }

    private deleteResourceType() {
        this.treeInstance.deleteResourceType();
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.treeInstance.updateTableInstance();
            this.treeInstance.$forceUpdate();
        }
    }
}
